module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0140.jpg?v=5c2a70b3";